import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportsRoutingModule } from './reports-routing.module';
import { POBComponent } from './pob/pob.component';
import { LiveAreaTrackingComponent } from './liveareatracking/liveareatracking.component';
import { MapTrackingComponent } from './maptracking/maptracking.component';
import { DayWiseCallComponent } from './daywisecall/daywisecall.component';
import { JointWorkingCallComponent } from './jointworkingcall/jointworkingcall.component';
import { ManagerTeamWiseCallComponent } from './managerteamwisecall/managerteamwisecall.component';
import { DailyRouteDivertComponent } from './dailyroutedivert/dailyroutedivert.component';
import { TPDeviationReportComponent } from './tpdeviationreport/tpdeviationreport.component';
import { HeadqtrAllocationReportComponent } from './headqtrallocationreport/headqtrallocationreport.component';
import { UserReportComponent } from './userreport/userreport.component';
import { LoggeUunoggedReportComponent } from './loggedunloggedreport/loggedunloggedreport.component';
import { DcrUnlockHistoryComponent } from './dcrunlockhistory/dcrunlockhistory.component';
import { PromotionalChemistReportComponent } from './promotionalchemistreport/promotionalchemistreport.component';
import { HQWisePOBReportComponent } from './hqwisepobreport/hqwisepobreport.component';
import { EmployeeWiseChemistComponent } from './employeewisechemist/employeewisechemist.component';
import { NewRetallerAddition } from './newretalleraddition/newretalleraddition.component';
import { TargetAndAchievementComponent } from './targetandachievement/targetandachievement.component';
import { leaveReportComponent } from './leaveReport/leaveReport.component';
import { EmployeeAttendaceComponent } from "./userreport/employeeattendace.component";
import { FirstLastComponent } from "./firstlastcall/firstlastcall.component";
import { LateWorkingReportComponent } from "./lateworking/lateworkingreport.component";
import { ExpenseEligiblityReportComponent } from "./expenseeligiblityreport/expenseeligiblity.component";
import { DailyExpenseReportComponent } from "./dailyexpensereport/dailyexpense.component";
import { NonListedCallComponent } from "./nonlistedcall/nonlistedcall.component";
import { SSStatementReportComponent } from "./ssstatementreport/ssstatementreport.component";
import { SSStatementlogComponent } from './ssstatementlog/ssstatementlog.component';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        AgGridModule.withComponents([]),
        ReportsRoutingModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        POBComponent,
        LiveAreaTrackingComponent,
        MapTrackingComponent,
        DayWiseCallComponent,
        JointWorkingCallComponent,
        ManagerTeamWiseCallComponent,
        DailyRouteDivertComponent,
        TPDeviationReportComponent,
        HeadqtrAllocationReportComponent,
        UserReportComponent,
        LoggeUunoggedReportComponent,
        DcrUnlockHistoryComponent,
        PromotionalChemistReportComponent,
        HQWisePOBReportComponent,
        EmployeeWiseChemistComponent,
        NewRetallerAddition,
        TargetAndAchievementComponent,
        leaveReportComponent,
        EmployeeAttendaceComponent,
        FirstLastComponent,
        LateWorkingReportComponent,
        ExpenseEligiblityReportComponent,
        DailyExpenseReportComponent,
        NonListedCallComponent,
        SSStatementReportComponent,
        SSStatementlogComponent
    ],
    providers: [],
    exports: [RouterModule]
})
export class ReportsModule {

}
